export default __webpack_public_path__ + "static/media/abishek_doshi.7506f63b.jpeg";